import React, { useState } from 'react';
import { Lock, ShieldAlert, KeyRound, ArrowRight } from 'lucide-react';

interface AdminAuthModalProps {
  onAuthenticated: () => void;
}

export const AdminAuthModal: React.FC<AdminAuthModalProps> = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validate password (19992017)
    if (password.trim() === '19992017') {
      sessionStorage.setItem('ym_admin_authed', 'true');
      onAuthenticated();
    } else {
      setError('Senha administrativa incorreta. Acesso negado.');
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md font-sans">
      <div className="max-w-md w-full animate-fade-in">
        <div className="p-8 border border-slate-200 bg-white rounded-3xl shadow-2xl">
          <div className="w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-600 border border-indigo-100 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-6 h-6" />
          </div>

          <h2 className="text-2xl font-black text-slate-900 text-center mb-2">Painel Administrativo</h2>
          <p className="text-xs text-slate-500 text-center mb-8">
            Área restrita de gestão de prospects e inteligência comercial YouMachine.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs font-extrabold text-slate-700 uppercase tracking-wider block mb-2">Senha de Acesso</label>
              <div className="relative">
                <input 
                  type="password"
                  placeholder="Digite a senha de administrador..."
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  className="w-full bg-slate-50 border border-slate-200 rounded-2xl px-4 py-3.5 text-sm text-slate-900 placeholder-slate-400 outline-none focus:border-indigo-600 focus:bg-white transition-all shadow-sm"
                  autoFocus
                />
                <KeyRound className="w-4 h-4 text-slate-400 absolute right-4 top-1/2 -translate-y-1/2" />
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 p-3 rounded-2xl bg-red-50 text-red-700 border border-red-200 text-xs font-semibold">
                <ShieldAlert className="w-4 h-4 shrink-0" />
                <span>{error}</span>
              </div>
            )}

            <button 
              type="submit"
              className="w-full py-3.5 rounded-2xl bg-indigo-600 hover:bg-indigo-700 text-white font-extrabold text-xs uppercase tracking-wider transition-colors flex items-center justify-center gap-2 shadow-md"
            >
              Acessar Painel <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
